<app-custom-modal #modal [title]="'Histórico de cobrança adicional por paciente'" [subtitle]="''" (onCloseClick)="modal.close()"
    [hideCancel]="true" [hideSave]="true">
    <section>
        <div class="row">
            <div class="col-auto p-0 d-flex align-items-center filter-container">
                <div class="input-group d-flex flex-column mx-2">
                    <label for="dataInicio" class="mb-1">Data início</label>
                    <div class="input-group">
                        <i class="input-group-text hgi hgi-stroke hgi-calendar-04"></i>
                        <input id="dataInicio" type="date" class="custom-date-input" name="dataInicio"
                            [(ngModel)]="dataInicio" (ngModelChange)="onDateChange()" />
                    </div>
                </div>

                <div class="input-group d-flex flex-column">
                    <label for="dataFinal" class="mb-1">Data final</label>
                    <div class="input-group">
                        <i class="input-group-text hgi hgi-stroke hgi-calendar-04"></i>
                        <input id="dataFinal" type="date" class="custom-date-input" name="dataFinal"
                            [(ngModel)]="dataFinal" (ngModelChange)="onDateChange()" />
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <button class="btn btn-filtros" (click)="limparFiltro()">
                Limpar filtros
                <i class="hgi hgi-stroke hgi-delete-02 ml-1"></i>
            </button>
        </div>

        <div class="table-container table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Valor</th>
                        <th>Data de início</th>
                        <th>Data final</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="
                let custo of custosAdicionais
                  | paginate
                    : {
                        id: 'server',
                        itemsPerPage: pageSize,
                        currentPage: pageNumber,
                        totalItems: totalItems
                      }
                ">
                        <td>{{custo.valor | currency:'BRL':'symbol'}}</td>
                        <td>{{custo.dataInicio | date: 'dd/MM/yyyy'}}</td>
                        <td>{{custo.dataFim | date: 'dd/MM/yyyy'}}</td>
                        <td>{{getStatus(custo)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="float-sm-right m-auto">
                    <abp-pagination-controls id="server" (pageChange)="getDataPage($event)">
                    </abp-pagination-controls>
                </div>
            </div>
        </div>
    </section>
</app-custom-modal>